import React from "react";

import { APIProvider } from "common/provider/APIProvider";

import { AppDependencyProvider } from "../App.dependencies";
import AuthProtected from "./components/AuthProtected";
import AccountLayoutView from "./views/AccountLayoutView";
import AdministrationLayoutView from "./views/AdministrationLayoutView";
import EmptyOutletLayoutView from "./views/EmptyOutletLayoutView";
import InfoLayoutView from "./views/InfoLayoutView";
import MainLayoutView from "./views/MainLayoutView";
import { RootLayoutView } from "./views/RootLayoutView";
import { AppContextProvider } from "../context/App/App.context";
import { AppSelectionContextProvider } from "../context/App/AppSelectionContext";
import { TempAppSelectionContextProvider } from "../context/App/TempAppSelectionContext";
import { UnreadNotificationsProvider } from "../context/App/UnreadNotificationsContext";
import { ShakingAnimationProvider } from "../context/ShakingAnimation/ShakingAnimationContext";
import { SubscriptionProvider } from "../context/Subscription/SubscriptionContext";

export function MainLayout() {
  return <MainLayoutView />;
}

export function RootLayout() {
  return (
    <AuthProtected>
      <AppDependencyProvider>
        <AppContextProvider>
          <AppSelectionContextProvider>
            <TempAppSelectionContextProvider>
              <SubscriptionProvider>
                <UnreadNotificationsProvider>
                  <APIProvider>
                    {/*<WebBanner /> uncomment to show banner*/}
                    <RootLayoutView />
                  </APIProvider>
                </UnreadNotificationsProvider>
              </SubscriptionProvider>
            </TempAppSelectionContextProvider>
          </AppSelectionContextProvider>
        </AppContextProvider>
      </AppDependencyProvider>
    </AuthProtected>
  );
}

export function AdministrationLayout() {
  return (
    <ShakingAnimationProvider>
      <AdministrationLayoutView />
    </ShakingAnimationProvider>
  );
}

export function InfoLayout() {
  return <InfoLayoutView />;
}

export function AccountLayout() {
  return <AccountLayoutView />;
}

export function EmptyOutletLayout() {
  return <EmptyOutletLayoutView />;
}
